import { homeDemoHousehold } from '@aithora/shared';
import { useConsoleRole, useSession } from '../../session/SessionContext';
import { useReadOnly, useReadOnlyReason } from '../../ui/ReadOnly';
import { EmptyState, Skeleton } from '../../ui/states';
import { useApi } from '../overview/common';
import { MemberHome } from './MemberHome';
import { OperatorHome } from './OperatorHome';
import './home.css';

/**
 * Aithora Home (Console V3 design T11033-12342, homeVals L24228). The role comes from
 * the session only:
 *   - a member (MEMBER) sees their own Home, five tabs;
 *   - Super Admin and Operator see the caseload, six tabs, and can open one member's
 *     Home read only ("view as member", chosen from the caseload);
 *   - a Super Admin viewing the console as the Aithora Home role sees the badged SAMPLE
 *     demo household (GET /home/demo-household), read only, because they have no Home.
 */
export function AithoraHome() {
  const { role, viewingAs } = useConsoleRole();
  const { session } = useSession();
  const readOnly = useReadOnly();
  const reason = useReadOnlyReason();
  const demo = useApi((c, signal) => homeDemoHousehold(c, { signal }), [], role === 'MEMBER' && !!viewingAs);
  if (!role || !session) return null;
  if (role === 'MEMBER') {
    if (!viewingAs) return <MemberHome personId={session.user.id} orgId={session.user.organizationId} readOnly={readOnly} reason={reason} />;
    if (demo.loading && !demo.data) return <Skeleton rows={4} />;
    if (demo.data?.available) return <MemberHome personId={demo.data.member.id} orgId={demo.data.member.organizationId} readOnly reason={reason} />;
    return <EmptyState title="No sample household to show" body="You have no Home of your own, and the sample household is not set up on this server." waitingOn="GET /home/demo-household" />;
  }
  return <OperatorHome />;
}
